/** Account / profile domain query segments */
export const AccountQueryKeys = {
  profile: {
    all: ['profile'] as const,
  },
};
